import { PowerBiDashboard } from '../report-dashboard/PowerBiReport';
import { HolisticsDashboard } from '../report-dashboard/HolisticsReport';
import './Dashboard.scss';
export const Dashboard = () => {
  const reportProvider = process.env.REACT_APP_REPORT_PROVIDER;
  const renderDashboard = () => {
    switch (reportProvider) {
      case 'powerbi':
        return <PowerBiDashboard />;
      case 'holistics':
        return <HolisticsDashboard />;
      default:
        return <PowerBiDashboard />;
    }
  }

  return (
    <div className='report-dashboard-container'>
      {renderDashboard()}
    </div>
  );
};